var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.1 45",
    style: {
      enableBackground: "new 0 0 44.1 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2,24l1.2-4.4c1.4-5.1,2-7.6,1.5-9.8c-0.4-1.7-1.3-3.3-2.6-4.5C39.6,3.7,37.1,3,32,1.7 c-5.1-1.3-7.6-2-9.8-1.5c-1.7,0.4-3.3,1.3-4.5,2.6c-1.3,1.4-2,3.5-3,7.2c-0.2,0.6-0.4,1.3-0.6,2l0,0l-1.2,4.3 c-1.4,5.1-2,7.6-1.5,9.8c0.4,1.7,1.3,3.3,2.6,4.5c1.6,1.5,4.2,2.2,9.3,3.6l0,0c4.6,1.2,7.1,1.9,9.1,1.6c0.2,0,0.5-0.1,0.7-0.1 c1.7-0.4,3.3-1.3,4.5-2.6C39.2,31.6,39.8,29,41.2,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,28.6L2.9,33c1.4,5.1,2,7.6,3.6,9.3c1.2,1.3,2.8,2.2,4.5,2.6c2.2,0.5,4.7-0.2,9.8-1.5 c5.1-1.4,7.6-2,9.3-3.6c0.1-0.1,0.3-0.3,0.4-0.4c-0.8-0.1-1.5-0.2-2.3-0.3c-1.6-0.3-3.4-0.8-5.6-1.4l-0.2-0.1h-0.1 c-2.4-0.7-4.4-1.2-6-1.8c-1.7-0.6-3.2-1.4-4.5-2.6c-1.8-1.7-3-3.8-3.6-6.2c-0.4-1.7-0.3-3.4,0-5.2c0.3-1.7,0.8-3.7,1.5-6.1l0,0 l1.2-4.5l0-0.2c-4.3,1.2-6.6,1.9-8.1,3.3c-1.3,1.2-2.2,2.8-2.6,4.5C-0.3,21,0.4,23.5,1.7,28.6L1.7,28.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.e14f3d17c995fd0093b936a3ce85eac5.svg";
export { ForwardRef as ReactComponent };